import styled, { css } from 'styled-components'
import { media } from '../../theme/breakpoints'

export type TextWeight =
    | 'bold'
    | 'medium'
    | 'semiBold'
    | 'regular'
    | 'paragraph'
export type TextSize =
    | 'xxxLarge'
    | 'xxLarge'
    | 'xLarge'
    | 'large'
    | 'medium'
    | 'small'
    | 'xSmall'
    | 'xxSmall'
    | 'xxxSmall'
export type TextColor =
    | 'none'
    | 'primary'
    | 'secondary'
    | 'brand'
    | 'error'
    | 'white'
    | 'information'

export const textWeightStyles = {
    bold: css`
        font-weight: ${(p) => p.theme.fontWeight.bold};
    `,
    semiBold: css`
        font-weight: ${(p) => p.theme.fontWeight.semiBold};
    `,
    medium: css`
        font-weight: ${(p) => p.theme.fontWeight.medium};
    `,
    regular: css`
        font-weight: ${(p) => p.theme.fontWeight.regular};
    `,
    paragraph: css`
        font-weight: ${(p) => p.theme.fontWeight.paragraph};
    `,
}

export const textSizeStyles = {
    xxxLarge: css`
        font-size: ${(p) => 42 / p.theme.baseFontSize}em;
        line-height: ${(p) => 48.3 / 42}em;
    `,
    xxLarge: css`
        font-size: ${(p) => 30 / p.theme.baseFontSize}em;
        line-height: ${(p) => 36 / 30}em;
    `,
    xLarge: css`
        font-size: ${(p) => 24 / p.theme.baseFontSize}em;
        line-height: ${(p) => 28.8 / 24}em;
    `,
    large: css`
        font-size: ${(p) => 20 / p.theme.baseFontSize}em;
        line-height: ${(p) => 24 / 20}em;
    `,
    medium: css`
        font-size: ${(p) => p.theme.baseFontSize / p.theme.baseFontSize}em;
        line-height: ${(p) => 28.8 / p.theme.baseFontSize}em;
    `,
    small: css`
        font-size: ${(p) => 16 / p.theme.baseFontSize}em;
        line-height: ${(p) => 25.6 / 16}em;
    `,
    xSmall: css`
        font-size: ${(p) => 14 / p.theme.baseFontSize}em;
        line-height: ${(p) => 18.2 / 14}em;

        ${media.mobile} {
            font-size: ${(p) => 16 / p.theme.baseFontSize}em;
            line-height: ${(p) => 25.6 / 16}em;
        }
    `,
    xxSmall: css`
        font-size: ${(p) => 12 / p.theme.baseFontSize}em;
        line-height: ${(p) => 19.2 / 12}em;

        ${media.mobile} {
            font-size: ${(p) => 16 / p.theme.baseFontSize}em;
            line-height: ${(p) => 25.6 / 16}em;
        }
    `,
    xxxSmall: css`
        font-size: ${(p) => 11 / p.theme.baseFontSize}em;
        line-height: ${(p) => 17.6 / 11}em;

        ${media.mobile} {
            font-size: ${(p) => 16 / p.theme.baseFontSize}em;
            line-height: ${(p) => 25.6 / 16}em;
        }
    `,
}

export const textColorStyles = {
    primary: css`
        color: ${(p) => p.theme.colors.tertiary.tertiary900};
    `,
    secondary: css`
        color: ${(p) => p.theme.colors.tertiary.tertiary600};
    `,
    brand: css`
        color: ${(p) => p.theme.colors.primary.default};
    `,
    error: css`
        color: ${(p) => p.theme.colors.primaryRed};
    `,
    white: css`
        color: ${(p) => p.theme.colors.white};
    `,
    information: css`
        color: ${(p) => p.theme.colors.blue.blue300};
    `,
    none: css`
        color: unset;
    `,
}

interface Props {
    size?: TextSize
    $weight?: TextWeight
    color?: TextColor
    $underline?: boolean
}

export const Text = styled.div<Props>`
    ${(props) => props.size && textSizeStyles[props.size]}
    ${(props) => props.$weight && textWeightStyles[props.$weight]}
    ${(props) => textColorStyles[props.color ?? 'primary']}

    ${(props) => props.$underline && 'text-decoration: underline;'}
`
